import Seo from "@/components/Seo";

export default function TermsPage() {
  return (
    <div className="container-edge py-16 md:py-24 max-w-3xl" data-testid="terms-page">
      <Seo
        title="Terms of Use | Simba Travel"
        description="Terms of use for simbatravel.co.uk — operated by Simba Limited (Reg. 09422922). Covers purpose, intellectual property, accuracy of information and governing law."
      />
      <div className="overline text-terracotta mb-4">Legal</div>
      <h1 className="editorial-h1 mb-8">Terms of Use</h1>
      <p className="text-sm text-muted2 mb-10">Last updated: February 2026</p>

      <div className="space-y-8 text-sm leading-relaxed text-ink/85">
        <section>
          <h2 className="editorial-h3 mb-3">1. About this website</h2>
          <p>This website is operated by Simba Limited (trading as Simba Travel), Company Registration No. 09422922, registered in England and Wales. By accessing simbatravel.co.uk you agree to these terms of use.</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">2. Purpose</h2>
          <p>simbatravel.co.uk provides information about Simba Travel's UK General Sales Agency (GSA) services and its partner airlines. Fare quotes and bookings are subject to the conditions of carriage of the operating airline.</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">3. Intellectual property</h2>
          <p>All content on this website (text, imagery, logos except partner logos which remain the property of their owners) is © Simba Limited unless otherwise stated. Do not reproduce without written permission.</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">4. Accuracy of information</h2>
          <p>We take care to ensure the accuracy of published fares, schedules and destination information but do not guarantee it. All bookings are confirmed only on ticket issuance by the operating airline.</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">5. Limitation of liability</h2>
          <p>To the extent permitted by law, Simba Limited shall not be liable for any indirect or consequential loss arising from use of this website.</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">6. Governing law</h2>
          <p>These terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the English courts.</p>
        </section>

        <section>
          <h2 className="editorial-h3 mb-3">7. Contact</h2>
          <p>Simba Limited, London, United Kingdom · <a href="mailto:Support@simbatravel.co.uk" className="text-terracotta hover:underline">Support@simbatravel.co.uk</a></p>
        </section>
      </div>
    </div>
  );
}
